import type { AdminIdentitySession } from "./api";

export const ADMIN_LOGIN_PATH = "/api/auth/admin/start";
export const CUSTOMER_ORDERS_PATH = "/?tab=ops&access=customer";

export function initialAccessMode(search: string): "admin" | "customer" {
  return new URLSearchParams(search).get("access") === "customer" ? "customer" : "admin";
}

/** Never auto-retry a failed callback or turn customer order queries into admin login. */
export function shouldStartCentralLogin(
  session: AdminIdentitySession,
  mode: "admin" | "customer",
  hasCustomerSession: boolean,
  callbackError: string | null
) {
  const canSignIn = !session.error || ["unauthorized", "accounts_session_expired"].includes(session.error);
  return session.provider === "accounts" && !session.authenticated && mode === "admin" &&
    !hasCustomerSession && !callbackError && canSignIn;
}
